module.exports = __webpack_public_path__ + "src/assets/img/activities_theater.f36e2dd4.jpg";